"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const components_1 = require("../../components");
const Icon_1 = require("../../components/Icon");
const Css_1 = require("../../Css");
const ChipSelectField_1 = require("../ChipSelectField");
/** Represents a single option within a ListBox - used by SelectField and MultiSelectField */
function Option(props) {
    const { item, state, contrast = false, scrollToIndex, disabledReason } = props;
    const ref = (0, react_1.useRef)(null);
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)({});
    const themeStyles = {
        item: Css_1.Css.gray900.if(contrast).white.$,
        hover: Css_1.Css.bgGray100.if(contrast).bgGray600.$,
        disabled: Css_1.Css.cursorNotAllowed.gray400.if(contrast).gray500.$,
        focus: Css_1.Css.add("boxShadow", `inset 0 0 0 1px ${!contrast ? Css_1.Palette.Blue700 : Css_1.Palette.Blue500}`).$,
    };
    // Get props for the option element.
    // Prevent options from receiving browser focus via shouldUseVirtualFocus.
    const { optionProps, isDisabled, isFocused, isSelected } = (0, react_aria_1.useOption)({ key: item.key, shouldSelectOnPressUp: true, shouldFocusOnHover: false }, state, ref);
    return (0, components_1.maybeTooltip)({
        title: disabledReason,
        placement: "right",
        children: ((0, jsx_runtime_1.jsxs)("li", { ...(0, react_aria_1.mergeProps)(optionProps, hoverProps), "data-label": item.textValue, ref: ref, css: {
                ...Css_1.Css.df.aic.jcsb.py1.px2.mh("42px").outline0.cursorPointer.sm.$,
                // Assumes only one Persistent Item per list - will need to change to utilize Sections if that assumption is incorrect.
                ...((0, ChipSelectField_1.isPersistentKey)(item.key) ? Css_1.Css.bt.bGray200.$ : {}),
                ...themeStyles.item,
                ...(isHovered && !isDisabled ? themeStyles.hover : {}),
                ...(isFocused ? themeStyles.focus : {}),
                ...(isDisabled ? themeStyles.disabled : {}),
            }, children: [item.rendered, isSelected && ((0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.$, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "check", color: !contrast
                            ? isDisabled
                                ? Css_1.Palette.Gray400
                                : Css_1.Palette.Blue700
                            : isDisabled
                                ? Css_1.Palette.Gray500
                                : Css_1.Palette.White }) }))] })),
    });
}
exports.Option = Option;
